import { Component, OnInit } from '@angular/core';

import { FormsModule } from '@angular/forms';

import { LxResponsiveClassDirective } from '../../../directives/lx-responsive-class.directive';
import { SharedService } from '../../../_services/shared.service';
import { ShoppingCartService } from '../../../_services/shopping-cart.service';
import { ThemeService } from '../../../_services/theme.service';
import { OfferService } from '../../../_services/offer/offer.service';

import { UiNewOfferPhotoTermsComponent } from '../ui-new-offer-photo-terms/ui-new-offer-photo-terms.component';

@Component({
  selector: 'ui-new-shopping-cart',
  standalone: true,
  imports: [FormsModule, LxResponsiveClassDirective],
  templateUrl: './ui-new-shopping-cart.component.html',
  styleUrls: ['./ui-new-shopping-cart.component.scss'],
})
export class UiNewShoppingCartComponent implements OnInit {
  constructor(
    public shoppingCartService: ShoppingCartService,
    public sharedService: SharedService,
    public themeService: ThemeService,
    public offerService: OfferService,
  ) {}

  ngOnInit() {}

  checkIfCartNotEmpty(): boolean {
    return this.shoppingCartService.getNumberOfOffersInShoppingCart(this.shoppingCartService.offerAliasId) > 0;
  }

  getNumberOfOffersInShoppingCart(): number {
    return this.shoppingCartService.getNumberOfOffersInShoppingCart(this.shoppingCartService.offerAliasId);
  }

  checkOut(): void {
    this.shoppingCartService.openCheckOutOfferTermsModal(
      this.shoppingCartService.offerAliasId,
      this.shoppingCartService.propId,
      UiNewOfferPhotoTermsComponent,
    );
  }

  openShoppingCartListModal(): void {
    this.shoppingCartService.openShoppingCartListModal(this.shoppingCartService.offerAliasId, this.shoppingCartService.propId);
  }
}
